import qs from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import { TopicFilterNames } from 'components/TopicFilters/shared';
import { EntityTypes } from 'context/entityContext';
import getCountryIds from 'helpers/getCountryIds';

export default getEquivalentsBreakdownURL;

interface IEquivalentsBreakdownURLArgs {
  entityType: EntityTypes;
  entityIds: string[];
  period?: string;
  countryIds?: string[];
  customerFilter?: TopicFilterNames[];
  limit?: number;
  download?: boolean;
  region?: string;
  customRegion?: string | string[];
}

function getEquivalentsBreakdownURL(
  args: IEquivalentsBreakdownURLArgs
): string {
  const {
    entityType,
    entityIds,
    period,
    countryIds,
    customerFilter,
    limit,
    download,
    region,
    customRegion,
  } = args;

  const params = qs.stringify({
    period,
    countryIds: getCountryIds(countryIds, region, customRegion),
    customerFilter,
    limit,
    download,
    regionBreakdown: region && !countryIds && !customRegion ? 'region' : 'none',
  });

  const type = entityTypeToApiType(entityType);

  return `/api/equivalents/breakdown/${type}/${entityIds}?${params}`;
}
